export default {
  getPickingList: (state) => state.pickingList,
  activePickingLists: (state) => state.pickingLists
    .filter((pickingList) => pickingList.completed === null),
  awaitingCheckPickingLists: (state) => state.pickingLists
    .filter((pickingList) => pickingList.completed === null && pickingList.picked !== null),
  completedPickingLists: (state) => state.pickingLists
    .filter((pickingList) => pickingList.completed !== null),
};
